import { Breadcrumbs, Button, FormControl, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { transaction } from "../validations/Validation";
import { toast } from "react-toastify";
import { postTransaction } from "../services/post.service";
import { patient, takenTreament } from "../common/type";

interface PaymentFields {
    takenTreatmentId: number;
    amount: number;
    description: string;
    purpose: string;
    toWhom: number;
}

const Payment = (props: { takenTreatment: takenTreament | null; patient: patient | null }) => {
    const { takenTreatment, patient } = props
    const { register, handleSubmit, formState: { errors } } = useForm<PaymentFields>({
        resolver: yupResolver(transaction)
    })
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    const OnSubmit = (data: any) => {
        setLoading(true)
        const load = toast.loading("Please wait...", {
            theme: "colored",
            type: "info",
            closeButton: true,
        })

        postTransaction(data)
            .then((res) => {
                toast.update(load, {
                    render: res.data,
                    type: "success",
                    theme: "colored",
                    autoClose: 2500,
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                });
                setLoading(false)
                navigate('/patient')
            })
            .catch((err) => {
                setLoading(false)
                console.log(err);
                toast.update(load, {
                    render: err?.response?.data?.detail,
                    theme: "colored",
                    autoClose: 5000,
                    type: "error",
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                });
            })
    }

    return <>
        <Helmet><title>Add Payment</title></Helmet>
        <div className="dark:text-black w-full">
            <div className="lg:m-12 m-4">
                <div className="bg-amber50 shadow-md rounded w-full lg:px-20 px-3 py-10 pt-5">
                    <div className="col-span-2">
                        <Breadcrumbs className="pb-5 color: rgb(0 0 0)" aria-label="breadcrumb">
                            <Link
                                color="black"
                                to="/patient"
                                className="hover:underline color: rgb(0 0 0)"
                            >
                                <Typography>Patient</Typography>
                            </Link>
                            <Link
                                color="black"
                                to="/patient/taken/treatment"
                                className="hover:underline color: rgb(0 0 0)"
                            >
                                <Typography>Taken Treatment</Typography>
                            </Link>
                            <Typography className="text-black">Add Payment</Typography>
                        </Breadcrumbs>
                        <Typography variant="h5">Add Payment</Typography>
                        <form className="lg:grid lg:grid-cols-3 py-5 lg:gap-3 flex flex-col gap-2" onSubmit={handleSubmit(OnSubmit)}>
                            <input type="hidden" {...register('toWhom')} value={patient ? patient.id : 0} />
                            <input type="hidden" {...register('takenTreatmentId')} value={takenTreatment ? takenTreatment.id : 0} />
                            <FormControl>
                                <TextField size="small" type="number" inputProps={{ step: '.01' }} label="Amount" {...register('amount')}
                                    error={errors.amount ? true : false} />
                                <p className="text-red-700">{errors.amount?.message}</p>
                            </FormControl>
                            <FormControl>
                                <TextField size="small" label="Description" {...register('description')}
                                    error={errors.description ? true : false} />
                                <p className="text-red-700">{errors.description?.message}</p>
                            </FormControl>
                            <FormControl>
                                <TextField size="small" label="Purpose" {...register('purpose')}
                                    error={errors.purpose ? true : false} />
                                <p className="text-red-700">{errors.purpose?.message}</p>
                            </FormControl>
                            <Button disabled={loading} className="col-span-3" variant="contained" type="submit">Add Payment</Button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </>;
};

export default Payment;
